import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

import { ICourse } from '@/interfaces/course';

export const useFacebookPixel = (course: ICourse) => {
  useEffect(() => {
    if (!course || !course.fc_pixel) return;
    ReactPixel.init(course.fc_pixel);
    ReactPixel.pageView();
  }, [course]);
};
